module.exports = __webpack_public_path__ + "static/media/folha1.50947cd5.png";